import React, { Component } from 'react';

class ThankYou extends Component {
    render() {
        return (
            <div className="alert alert-success" style={{marginTop: 50}}>
                <h3>Thank You!</h3> 
                <p>
                    Thank you for ordering from Wrightbalance. Your results have beeen sent to your email. 
                        If you do not receive  an email from us, please check your spam folder. 
                        If the problem persists, please contact us.
                </p>
                
                <br/>

            </div>
        );
    }
}

export default ThankYou



// WEBPACK FOOTER //
// ./src/pages/containers/ThankYou.js